import { useMemo } from "react";

import { useSmartrrCustomerSelector } from "@customer-app/state/typedCustomerReduxHooks";

export const useGetAllSellingPlanGroups = () => {
  const publicGroups = useSmartrrCustomerSelector(state => state.sellingPlanGroups.sellingPlanGroupList);
  const addonGroups = useSmartrrCustomerSelector(state => state.sellingPlanGroups.addOnsConfigs);
  const trendingGroups = useSmartrrCustomerSelector(state => state.sellingPlanGroups.trendingConfigs);

  return useMemo(() => {
    return [...publicGroups, ...addonGroups, ...trendingGroups];
  }, [publicGroups, addonGroups, trendingGroups]);
};
